export const UserAttributeTypeIDCustom = '2JeqCdVXEdRxENgnRDBK1zYxkv4'
export const UserAttributeTypeIDAdditionalEmail = '2v9PJiFGPUF075p8mcTRVC9XnHo'
export const UserAttributeTypeIDAdditionalEmployeeID = '2uxbo6R92kG45kPwcvzdQNYLbbK'
export const UserAttributeTypeIDAdditionalUsername = '2esCKj2ccJZuJzHMePsQCWL32SH'
export const UserAttributeTypeIDManager = '2JeqCdWPI33CD3uBE34vo7jlMea'
export const UserAttributeTypeIDDirectoryStatus = '2KAXsP69lK9vRRFE6sIOP5jK23j'
